<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'
import IcAnimateSpin from '@/components/Icons/IcAnimateSpin.vue'

defineProps<{
  hasMore: boolean
  isLoadingMore: boolean
  loadedCount: number
  totalCount: number
  remainingCount: number
}>()

const emit = defineEmits<{
  'load-more': []
}>()

const { t } = useI18n()
</script>

<template>
  <div v-if="hasMore || loadedCount > 0" class="mt-4 flex flex-col items-center gap-2">
    <button
      v-if="hasMore"
      type="button"
      class="flex items-center gap-1.5 rounded-none border border-primary bg-white px-3 py-1.5 text-xs font-medium text-primary transition hover:bg-primary hover:text-white disabled:opacity-50"
      :disabled="isLoadingMore"
      @click="emit('load-more')">
      <IcAnimateSpin v-if="isLoadingMore" class="h-3 w-3 shrink-0 text-current" />
      <ChevronDownIcon v-else class="h-3 w-3 shrink-0" aria-hidden="true" />
      {{
        isLoadingMore
          ? t('daily_temperature.pagination.loading')
          : t('daily_temperature.pagination.load_more', { remaining: remainingCount })
      }}
    </button>

    <p v-if="loadedCount > 0" class="text-center text-xs text-gray-500">
      {{
        t('daily_temperature.pagination.showing', {
          loaded: loadedCount,
          total: totalCount,
        })
      }}
    </p>
  </div>
</template>
